import { EnrichmentPlugin, Event } from '@amplitude/analytics-types';

import { AmplitudeAutoTrackEvents } from '@/components/Analytics/amplitude.types';
import { AmplitudePageName, getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

/**
 * Adds Page Name to autocapture page views on article routes.
 * Registered before amplitude.init so it is on the timeline before the first page view fires.
 */
export class ArticlePagePropertiesPlugin implements EnrichmentPlugin {
    name = 'article-page-properties-plugin';
    type = 'enrichment' as const;

    execute = async (event: Event) => {
        const autoTrackUrl = event.event_properties?.['[Amplitude] Page URL'];
        const isArticlePageView =
            event.event_type === AmplitudeAutoTrackEvents.PageViewed &&
            typeof autoTrackUrl === 'string' &&
            getAmplitudePageNameFromPath(autoTrackUrl) === AmplitudePageName.Article;

        if (isArticlePageView) {
            event.event_properties['Page Name'] = AmplitudePageName.Article;
        }

        return event;
    };
}
